/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global CONTENT */

function Reporter() {
  if (!this instanceof Reporter) return new Reporter();

  var that = this;

  this.stack = [];

  //init
  window.addEventListener("error", handler);

  function handler(e) {
    console.warn(e);

    var errStr = e;
    if (e.error && e.error.stack) errStr = e.error.stack;
    else if (e.message) errStr = e.message;

    var state = stringify({
      error: errStr,
      content: CONTENT,
    });
    that.stack.push(state);

    //open new window with some explenation to user
    var html = `
        <h1>Fehlerbericht</h1>
        <span style="font-size: 1.5em;">Sehr geehrter Nutzer,
        leider ist auf unserer Seite ein Fehler aufgetreten. Sie würden uns und somit auch sich selbst sehr behilflich sein, wenn sie den nachfolgenden Text an die folgende E-Mail senden würden.<br>
        Bitte beachten Sie, dass es sich hierbei um die Fehlermeldung und den aktuellen Zustand der App in Ihren Browser handelt und somit sensible Daten enthalten sein könnten.<br>
        Da wir jedoch die App hosten und auf die Datenbank Zugriff haben, sollte dies für den Versand an uns keine Relevanz haben.<br>
        Unsere E-Mail: k.klockgether@28apps.de<br>
        </span><br>
        Nun der Fehlerbericht. Kryptisch, aber wir können sehr viel damit anfangen ;)<br><br>

        <code>${state}</code>`;

    //TODO send to server
    //var win = window.open();
    //win.document.write(html);
  }

  /**
   * Parse <i>obj</i> to JSON.
   * Takes care of circular structures and replace them trough a string.
   * @param {object} obj
   * @returns {String}
   */
  function stringify(obj) {
    var done = [];

    return JSON.stringify(obj, replacer);

    /**
     * Catch circular structures
     * @param {String} key
     * @param {*} value
     * @returns {undefined}
     */
    function replacer(key, value) {
      switch (typeof value) {
        case "function":
          return undefined;

        case "object":
          //element already used?
          if (value !== null && done.indexOf(value) !== -1)
            return "/* - circle reference - */";
          done.push(value);
          return value;

        default:
          if (key === "html") return "/* - html - */";
          return value;
      }
    }
  }
}
